import sanityQuery from '~/sanity/queries/product-category'
import { colors as recessColors } from '~/recess.json'

export default {
  async asyncData({
    route,
    params,
    query,
    store,
    env,
    $sanity,
    $sentry,
    error
  }) {
    let slug
    let colors
    if (params.category) {
      slug = params.category
      // TODO: make this less brittle?
    } else if (
      route.name === 'sparkling-water' ||
      route.name === 'shop-sparkling-water'
    ) {
      slug = 'sparkling-water'
      colors = {
        backgroundColors: [recessColors.apricot],
        textColor: recessColors['cloud-burst']
      }
    } else if (route.name === 'recess-mood') {
      slug = 'recess-mood'
    } else if (route.name === 'mood-powder-tubs') {
      slug = 'mood-powder-tubs'
    } else if (route.name === 'recess-mood-powders') {
      slug = 'mood-powders'
    } else if (route.name === 'powder-stick-pack') {
      slug = 'powder-stick-pack'
    } else if (route.name === 'mood-powders') {
      slug = 'recess-mood-powders'
    } else if (route.name === 'shop-realitywear') {
      slug = 'realitywear'
    } else if (route.name === 'zero-proof') {
      slug = 'zero-proof'
    } else {
      return error({
        statusCode: 404,
        message: "Category doesn't exist"
      })
    }
    const previewId = query.preview
    try {
      const category = await $sanity.fetch(
        sanityQuery(
          slug,
          previewId,
          env.nonCBDSite ? 'home-non-cbd' : undefined
        )
      )

      if (!category) {
        throw new Error('Category not found')
      }

      if (env.nonCBDSite && category.cbd) {
        return error({
          statusCode: 404,
          message: 'Not Found'
        })
      }

      if (category.backgroundColors?.length > 0) {
        // ideally all category background colors are defined in the CMS but
        // the page design would need to be tweaked
        colors = {
          backgroundColors: category.backgroundColors.map(({ hex }) => hex)
        }
      }

      if (colors) {
        store.commit('screen/setPageColors', colors)
      }
      return {
        title: category.title,
        category,
        colors
      }
    } catch (e) {
      $sentry.captureException(e)
      return error({
        statusCode: 404,
        message: e.message
      })
    }
  },

  mounted() {
    const { backgroundImages } = this.category
    if (backgroundImages && backgroundImages.length >= 1) {
      this.$store.commit('screen/setBackgroundImages', backgroundImages)
    }
  },

  beforeDestroy() {
    this.$store.commit('screen/setBackgroundImages', [])
  },

  data: () => ({
    category: null
  })
}
